import api from '../api';
import axios from 'axios';

export default {
    // Extra assignees of a ticket: [{id, name, email}]
    GET: (taskId) => axios.get(process.env.REACT_APP_BACKEND_URL + api.taskAssignee.GET(taskId)),
    // Replace the extra assignees: {userIds: []}
    SET: (taskId, userIds) => axios.put(process.env.REACT_APP_BACKEND_URL + api.taskAssignee.SET(taskId), { userIds }),
};
